<template>
    <div>
        <h1>RENJA PERMENDAGRI</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
